import { createAction, props } from '@ngrx/store';

import { RequestsOverviewModel } from '../../../overview/models/overview.model';

export const requestMakeMatch = createAction(
  '[Request] Make match on selected request',
  props<{ requestId: number }>(),
);

export const requestMakeMatchSuccess = createAction(
  '[Request] Make match on selected request success',
  props<{ response: RequestsOverviewModel }>(),
);
